(function (angular) {
    'use strict';
    var app = angular.module('enervee.fastTrack');

    /*
     Creates a new controller for the rebate Fast Track form errors modal
     */
    app.controller('fastTrackErrorsModalCtrl', [
        '$uibModalInstance',
        'AnalyticsService',
        'FastTrackUploadReceiptsService',
        'initialScope',
        function (
            $uibModalInstance,
            AnalyticsService,
            FastTrackUploadReceiptsService,
            initialScope
        ) {
            var vm = this;

            vm.errorType = initialScope.errorType;
            vm.switchViews = initialScope.switchViews;
            vm.rebatedProducts = FastTrackUploadReceiptsService.getRebatedProducts();

            vm.dismissModal = function (reason) {
                $uibModalInstance.dismiss(reason || 'cancel');
                vm.reportErrorType()
            };

            vm.back = function () {
                vm.switchViews('rebates-application');
                vm.reportErrorType()
            };

            vm.reportErrorType = function () {
                if (vm.errorType == 'error-no-available-rebates') {
                    AnalyticsService.reportEvent('No Available Rebates');
                } else {
                    AnalyticsService.reportEvent('Fast Track Failed');
                }
            };
        }
    ]);

})(angular);
